import React, { useEffect, useRef, useState } from "react";
import { Box, Flex, Image, Input, Text, Tabs,Tab,TabList, TabPanels,Heading, Spacer, IconButton,Textarea, Checkbox, Button,Stack,TabPanel, Td, Tr  } from "@chakra-ui/react";
import MiniSideBar from "../../components/mini-sidebar";
import Loader from "../../components/loader/loader";
import { useNavigate } from "react-router-dom";
import useLoader from "../../components/loader/loaderstates";
import SecondaryNav from "../../components/seconday-nav";
import { DropdownInput, PrimaryButton, PrimaryInput, Toaster } from "../../components";
import { FaRegSave } from "react-icons/fa";
import { CopyIcon } from "@chakra-ui/icons";
import { CgRemove } from "react-icons/cg";
import { COLORS } from "../../components/styles/colors";
import { formatDate_Do_MMM_YYYY, formatDate_Do_MMM_YYYY_Time, formatDate_YYYY_MM_DD, getLoginID, uploadImageCommonFunction, useScreenType } from "../../auth";
import MobileNavbar from "../../components/mobile-navbar";
import MobileSecondaryNav from "../../components/mobile-secondary-navbar";
import { MdDownload } from "react-icons/md";
import { MdOutlineMailOutline } from "react-icons/md";
import { guid } from "@fullcalendar/core/internal";
import { CONFIG } from "../../appconfig/appconfig";
import { UploadInvoiceToFetchDetails, SaveInvoiceData } from "../../middleware/services/procurementmanagement";
import SimpleTable from "../../components/simple-table";
import moment from "moment";
import { FetchTransferMedicineList, getSupplier } from "../../middleware/services/profile";
import DropdownInputForVitals from "../../components/dropdown-input-forVitals";
import DatePicker from "../../components/date-picker";
import DynamicModal from "../../components/dynamic-modal";

// import { uploadImageCommonFunction, uploadPdfBaseURL } from "../../auth";

const UploadInvoice = () => {
      const [selectedTab, setSelectedTab] = useState("doctor");
      // const [hideSection, sethideSection] = useState(false);
      const {showSuccessToast, showErrorToast} = Toaster();

      const [docUpload, setDocUpload] = useState(true);
      const [previewDoc, setPreviewDoc] = useState(false);
      const [hideMobile, setHideMobile] = useState(false);
      const [dispContent, setDispContent] = useState(false);
     
  const navigate = useNavigate();
  const { isLoading, showLoader, dismissLoader } = useLoader();
  const screenType = useScreenType()

  // ----------------------- Upload Document -----------------------------
    const [selectedImage, setSelectedImage] = useState(null);
    const [data, setData] = useState(null);
  
  const [base64PDF, setBase64PDF] = useState("");
  const [pdfUrl, setPdfUrl] = useState("");
  const [docUrl, setDocUrl] = useState("");
  const [AIInput, setAIInput] = useState(null);
  const [dischargeSummary, setDischargeSummary] = useState(null);
  const [downloadSummaryId, setDownloadSummaryId] = useState(null);
  const [Showdata, SetShowData] = useState(false);
  const [selectedImages, setSelectedImages] = useState([]); // Stores multiple file previews
  const [fileurl, setFileURL] = useState(null); // Stores multiple file previews


  const handleuploadDocumentAttachment = () => {
    document.getElementById("uploaddocument").click();
  }
const handleUploadDocument = async (e) => {
  e.preventDefault();
  const file = e.target.files[0]; // Only take the first file

  if (!file) {
    console.error("No file selected");
    return;
  }

  const reader = new FileReader();
  reader.onloadend = () => {
    const base64Data = reader.result.split(",")[1];
    setSelectedImages([{ name: file.name, url: reader.result, type: file.type }]);
    setAIInput({ data: base64Data });
  };

  reader.readAsDataURL(file);

  setDocUpload(false);
  setPreviewDoc(true);
  setHideMobile(true);
};

// existing function
// const handleUploadFiles = async () => {
//   setFileURL(null);

//   if (!selectedImages || selectedImages.length === 0) {
//     console.error("No file selected for upload");
//     return;
//   }

//   const file = selectedImages[0]; // Only take the first file

//   try {
//     let fileToUpload;

//     if (file.url.startsWith("data:")) {
//       const byteString = atob(file.url.split(",")[1]);
//       const mimeType = file.type;
//       const arrayBuffer = new ArrayBuffer(byteString.length);
//       const intArray = new Uint8Array(arrayBuffer);
//       for (let i = 0; i < byteString.length; i++) {
//         intArray[i] = byteString.charCodeAt(i);
//       }

//       fileToUpload = new File([intArray], file.name, { type: mimeType });
//     } else {
//       fileToUpload = new File([file], file.name, { type: file.type });
//     }

//     const response = await uploadImageCommonFunction(fileToUpload, fileToUpload.name);
//     let blobURL = "";
//     var doctorDetails = localStorage.getItem("LoginInfo");
//     if (doctorDetails) {
//       var formateddata = JSON.parse(doctorDetails);
//       blobURL = formateddata.imagepath;
//     }
//     if (response) {
//       setFileURL(response.name); // Save only one name
//       showLoader();
//       let input = {link: blobURL +response.name}
//         try{
//           const result = await UploadInvoiceToFetchDetails(input);
//           console.log('dataaaaaaaaaaaaa: ', result.data)
//           if(result) {
//             console.log(result.data);
//             SetShowData(true);
//             setData(result.data);
//           }else {
//             showErrorToast("Something went wrong");
//           }
//           dismissLoader();
//         }catch(error) {
//             console.error("API Error:", error);
//         }
      
//     } else {
//       console.error(`Failed to upload ${file.name}`);
//     }
//   } catch (error) {
//     console.error(`Error processing file ${file.name}:`, error);
//   }
// };

const [uploadedFileInfo, setUploadedFileInfo] = useState({
  blobURL: "",
  fileName: ""
});
const handleUploadFiles = async (isRefetch = false) => {
  // Check subscription first
  if (!isChatbotAllowed()) {
    showErrorToast("Please upgrade your subscription to use AI features");
    return;
  }

  setFileURL(null);

  // If refetching and we already have the file info
  if (isRefetch && uploadedFileInfo.blobURL && uploadedFileInfo.fileName) {
    try {
      showLoader();
      let input = { link: uploadedFileInfo.blobURL + uploadedFileInfo.fileName };
      const result = await UploadInvoiceToFetchDetails(input);
      
      if (result) {
        console.log(result.data);
        SetShowData(true);
        setData(result.data);
      } else {
        showErrorToast("Something went wrong");
      }
      dismissLoader();
    } catch (error) {
      console.error("API Error:", error);
      dismissLoader();
    }
    return;
  }

  // Original upload logic
  if (!selectedImages || selectedImages.length === 0) {
    console.error("No file selected for upload");
    return;
  }

  const file = selectedImages[0];

  try {
    let fileToUpload;

    if (file.url.startsWith("data:")) {
      const byteString = atob(file.url.split(",")[1]);
      const mimeType = file.type;
      const arrayBuffer = new ArrayBuffer(byteString.length);
      const intArray = new Uint8Array(arrayBuffer);
      for (let i = 0; i < byteString.length; i++) {
        intArray[i] = byteString.charCodeAt(i);
      }
      fileToUpload = new File([intArray], file.name, { type: mimeType });
    } else {
      fileToUpload = new File([file], file.name, { type: file.type });
    }

    const response = await uploadImageCommonFunction(fileToUpload, fileToUpload.name);
    let blobURL = "";
    var doctorDetails = localStorage.getItem("LoginInfo");
    if (doctorDetails) {
      var formateddata = JSON.parse(doctorDetails);
      blobURL = formateddata.imagepath;
    }
    
    if (response) {
      setFileURL(response.name);
      // Save the file info for potential refetch
      setUploadedFileInfo({
        blobURL: blobURL,
        fileName: response.name
      });
      
      showLoader();
      let input = { link: blobURL + response.name };
      try {
        const result = await UploadInvoiceToFetchDetails(input);
        if (result) {
          console.log(result.data);
          SetShowData(true);
          setData(result.data);
        } else {
          showErrorToast("Something went wrong");
        }
        dismissLoader();
      } catch (error) {
        console.error("API Error:", error);
        dismissLoader();
      }
    } else {
      console.error(`Failed to upload ${file.name}`);
    }
  } catch (error) {
    console.error(`Error processing file ${file.name}:`, error);
  }
};
const handleRefetchInvoice = () => {
  handleUploadFiles(true)
}
const generateRandomNumberCode = () => {
  return Math.floor(100000 + Math.random() * 900000).toString();
};


  // Remove a selected file from preview
  const handleRemoveFile = (fileName) => {
      setSelectedImages(selectedImages.filter(file => file.name !== fileName));
      // navigate('/procurements')
      setDocUpload(true)
  };
  const TableHeader = [
    //{ key: "sno", label: "S.No" },
    { key: "hsn", label: "HSN" },
    // { key: "manufacturer", label: "Manufacturer" },
    { key: "productname", label: "Product Name" },
    { key: "producttype", label: "Product Type" },
    { key: "strength", label: "Strength" },
    { key: "strengthunit", label: "Strength Unit" },
    { key: "pack", label: "Pack" },
    { key: "qty", label: "Qty" },
    { key: "mrp", label: "MRP" },
    { key: "batch", label: "Batch" },
    { key: "expiry", label: "Expiry" },
    { key: "amount", label: "Amount" },
  ];
  let finaloutput = {
    "grand_total_amount": "20910.00",
    "name_of_company": "NYX PHARMACEUTICALS PVT. LTD.",
    "GSTIN": "04AAGCN6190F1ZI",
    "invoice_no": generateRandomNumberCode(),
    "invoice_date": "2025-04-24",
    "invoiceurl":fileurl,
    "products": [
      {
        "HSN": "30049061",
        "product_number": "CEFTANY-TZ 1.125GM",
        "pack": "VIAL",
        "qty": "20",
        "batch": "G24L07A",
        "MRP": "449.90",
        "exp": "11/26",
        "amount": "1300.00"
      },
      {
        "HSN": "30049061",
        "product_number": "CEFTANY FORT 1.120",
        "pack": "VIAL",
        "qty": "20",
        "batch": "SR1422096",
        "MRP": "449.90",
        "exp": "6/26",
        "amount": "1300.00"
      },
      {
        "HSN": "30049061",
        "product_number": "CEFTONY-X 1.5GM INJ",
        "pack": "1X1",
        "qty": "20",
        "batch": "G24L05A",
        "MRP": "449.90",
        "exp": "9/26",
        "amount": "1300.00"
      },
      {
        "HSN": "30049061",
        "product_number": "CEFTONY-TZ 1.125",
        "pack": "1X1",
        "qty": "20",
        "batch": "SRIF240039",
        "MRP": "499.90",
        "exp": "5/26",
        "amount": "1870.00"
      },
      {
        "HSN": "30049061",
        "product_number": "ACITROM-SB 1.5",
        "pack": "1X1",
        "qty": "20",
        "batch": "SRK230039",
        "MRP": "299.90",
        "exp": "10/26",
        "amount": "1180.00"
      },
      {
        "HSN": "30049061",
        "product_number": "CEFINYX-S 1.5",
        "pack": "1X1",
        "qty": "20",
        "batch": "G24K86",
        "MRP": "449.90",
        "exp": "12/26",
        "amount": "1300.00"
      },
    ],
  }
// const saveInvoice = async () => {
//   data.invoice_date = formatDate_YYYY_MM_DD(data.invoice_date);
//   delete data.cost_usd;

//   // Sanitize products array
//   if (Array.isArray(data.products)) {
//     data.products = data.products.map(product => {
//       // Handle MRP
//       const updatedMRP = product.MRP === '' || product.MRP === undefined ? null : product.MRP;

//       // Handle qty: if it's a whole number like 5.00, convert to 5
//       let updatedQty = product.qty;
//       if (!isNaN(updatedQty)) {
//         const parsedQty = parseFloat(updatedQty);
//         updatedQty = Number.isInteger(parsedQty) ? parseInt(parsedQty) : parsedQty;
//       }

//       return {
//         ...product,
//         MRP: updatedMRP,
//         qty: updatedQty
//       };
//     });
//   }

//   // Include invoice URL
//   data.invoiceurl = fileurl;

//   try {
//     const result = await SaveInvoiceData(data);

//     if (result && result.output.result === 'success') {
//       showSuccessToast("Details saved successfully");
//       navigate("/procurements");
//     }

//   } catch (error) {
//     console.error("API Error:", error);
//   }
// };


const isValidDate = (dateString) => {
  // Check formats: MM/YYYY, DD/MM/YYYY, or MM/YY
  const formats = [
    /^(0[1-9]|1[0-2])\/\d{4}$/,      // MM/YYYY
    /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/,  // DD/MM/YYYY
    /^(0[1-9]|1[0-2])\/\d{2}$/       // MM/YY
  ];

  // Check if string matches any format
  if (!formats.some(format => format.test(dateString))) {
    return false;
  }

  // Additional validation for actual date values
  try {
    let day, month, year;
    
    if (dateString.includes('/')) {
      const parts = dateString.split('/');
      
      if (parts.length === 2) { // MM/YY or MM/YYYY
        month = parseInt(parts[0], 10);
        year = parseInt(parts[1], 10);
        year = year < 100 ? 2000 + year : year; // Handle YY -> YYYY
        day = 1; // Default day for month/year formats
      } else if (parts.length === 3) { // DD/MM/YYYY
        day = parseInt(parts[0], 10);
        month = parseInt(parts[1], 10);
        year = parseInt(parts[2], 10);
      }
      
      // Check if the date is valid
      const date = new Date(year, month - 1, day);
      return date.getFullYear() === year && 
             date.getMonth() === month - 1 && 
             date.getDate() === day;
    }
    
    return false;
  } catch (e) {
    return false;
  }
};
// const isValidDate = (dateString) => {
//   // Simple check for common date formats
//   return /^\d{2}\/\d{4}$/.test(dateString) ||  // MM/YYYY
//          /^\d{2}\/\d{2}\/\d{4}$/.test(dateString);  // DD/MM/YYYY
// };
const saveInvoice = async () => {

   // Validate required fields
  const requiredFields = [
    'product_name', 
    'product_type',
    'strength',
    'strength_unit',
    'pack',
    'qty',
    'batch',
    'exp'
  ];

  // Check each product for required fields
  for (let i = 0; i < editableData.products.length; i++) {
    const product = editableData.products[i];
    
    // Validate product name
    if (!product.product_name || product.product_name.trim() === '') {
      showErrorToast(`Product name is required in row ${i + 1}`);
      return;
    }

    // Validate product type
    if (!product.product_type || product.product_type.trim() === '') {
      showErrorToast(`Product type is required in row ${i + 1}`);
      return;
    }

    // Validate strength
    if (!product.strength || product.strength.trim() === '') {
      showErrorToast(`Strength is required in row ${i + 1}`);
      return;
    }

    // Validate strength unit
    if (!product.strength_unit || product.strength_unit.trim() === '') {
      showErrorToast(`Strength unit is required in row ${i + 1}`);
      return;
    }

    // Validate pack
    if (!product.pack || product.pack.trim() === '') {
      showErrorToast(`Pack is required in row ${i + 1}`);
      return;
    }

    // Validate quantity
    if (!product.qty || isNaN(product.qty) || Number(product.qty) <= 0) {
      showErrorToast(`Valid quantity is required in row ${i + 1}`);
      return;
    }

    // Validate batch
    if (!product.batch || product.batch.trim() === '') {
      showErrorToast(`Batch number is required in row ${i + 1}`);
      return;
    }

    // Validate expiry
    if (!product.exp || product.exp.trim() === '') {
      showErrorToast(`Expiry date is required in row ${i + 1}`);
      return;
    }
    
    // Additional validation for expiry date format if needed
    if (!isValidDate(product.exp)) {
      showErrorToast(`Invalid expiry date format in row ${i + 1}. Use MM/YYYY or DD/MM/YYYY or MM/YY`);
      return;
    }
  }

  // Use editableData instead of data
  const saveData = {
    ...editableData,
    invoice_date: formatDate_YYYY_MM_DD(editableData.invoice_date),
    name_of_company: selectedSupplier || editableData.name_of_company || data?.name_of_company || ''
  };
  
  delete saveData.cost_usd;

  // Sanitize products array
  if (Array.isArray(saveData.products)) {
    saveData.products = saveData.products.map(product => {
      // Handle MRP
      const updatedMRP = product.MRP === '' || product.MRP === undefined ? null : product.MRP;

      // Handle qty: if it's a whole number like 5.00, convert to 5
      let updatedQty = product.qty;
      if (!isNaN(updatedQty)) {
        const parsedQty = parseFloat(updatedQty);
        updatedQty = Number.isInteger(parsedQty) ? parseInt(parsedQty) : parsedQty;
      }

      // return {
        const sanitizedProduct = {
        ...product,
        MRP: updatedMRP,
        qty: updatedQty,
        medicinetype: product.product_type
      };

      // Remove the producttype field if it exists
      delete sanitizedProduct.product_type;

      return sanitizedProduct;
    });
  }

  saveData.invoiceurl = fileurl;

  try {
    const result = await SaveInvoiceData(saveData);

    if (result && result.output.result === 'success') {
      showSuccessToast("Details saved successfully");
      navigate("/procurements");
    }
  } catch (error) {
    console.error("API Error:", error);
  }
};


const [editableData, setEditableData] = useState(data);
// const [editableData, setEditableData] = useState({
//   ...data,
//   products: data.products.map(product => ({
//     ...product,
//     producttype: product.producttype || '' // Initialize empty if null
//   }))
// });

useEffect(() => {
  setEditableData(data);
}, [data]);

const handleInputChange = (index, field, value) => {
  const updatedProducts = [...editableData.products];
  updatedProducts[index] = {
    ...updatedProducts[index],
    [field]: value
  };
  
  setEditableData({
    ...editableData,
    products: updatedProducts
  });
};

const handleInvoiceDetailsChange = (field, value) => {
  setEditableData({
    ...editableData,
    [field]: value
  });
};

const [invoiceDate, setInvoiceDate] = useState(null);

useEffect(() => {
  if (data?.invoice_date) {
    try {
      const dateParts = data.invoice_date.split('-');
      if (dateParts.length === 3) {
        const parsedDate = new Date(`${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`);
        if (!isNaN(parsedDate.getTime())) {
          setInvoiceDate(parsedDate);
        }
      }
    } catch (e) {
      console.error("Date parsing error:", e);
    }
  }
}, [data?.invoice_date]);
const handleDateChange = (selectedDate) => {
  setInvoiceDate(selectedDate);
  
  // Format the date back to "DD-MM-YYYY" string for storage
  const day = selectedDate.getDate().toString().padStart(2, '0');
  const month = (selectedDate.getMonth() + 1).toString().padStart(2, '0');
  const year = selectedDate.getFullYear();
  const formattedDate = `${day}-${month}-${year}`;
  
  handleInvoiceDetailsChange('invoice_date', formattedDate);
};

const [selectedSupplier, setSelectedSupplier] = useState(data?.name_of_company || '');
  const [supplierOptions, setSupplierOptions] = useState([]);
    const [supplierData, setSupplierData] = useState([]);
  
      // useEffect(() => {
      // }, [])
    useEffect(() => {
      FetchSupplierList()
      if (data) {
        setSelectedSupplier(data.name_of_company || '');
      }
}, [data]);

const FetchSupplierList = async () => {
      var inputForGet = {
        doctorid: getLoginID(),
        searchtext: "",
        fromdate: "",
        todate: "",
        // pagenumber: pageno,
        // pagesize: pagesize,
      };
      showLoader();
      try {
        var result = await getSupplier(inputForGet);
        // console.log(result, 'result')
  
        if (result && result.output.data) {
          setSupplierData(result.output.data);

        const options = result.output.data.map(supplier => supplier.suppliername);
          setSupplierOptions(options);
        }else {
          setSupplierData([])
          setSupplierOptions([]);
        }
      } catch (error) {
        console.log(error, "Something went wrong in doctor profile");
      } finally {
        dismissLoader();
      }
    };

    const handleSupplierSelect = (selectedName) => {
        setSelectedSupplier(selectedName);

        // Also update the editableData if you're using it
        setEditableData(prev => ({
          ...prev,
          name_of_company: selectedName
        }));
      };

      const handleInputSupplierChange = (e) => {
  const value = e.target.value;
  setSelectedSupplier(value);
  setEditableData(prev => ({
    ...prev,
    name_of_company: value
  }));
};

// ------------------------------------------------------------------------
// Medicine Types/ Strenght unit dropdown 

// const [medicinetype, setMedicineType] = useState("");
const [selectedProductType, setSelectedProductType] = useState(data?.producttype || '');
const [selectedStrengthUnit, setSelectedStrengthUnit] = useState(data?.strength_unit || '');

const medicineTypes = [
    "Tablet",
    "Capsule",
    "Syrup",
    "Injection",
    "Ointments / Creams / Gels",
    "Drops",
    "Nebulization",
    "IVFluids",
    "Inhaler",
  ];
  const medicineTypeMapping = {
  'TAB': 'Tablet',
  'CAP': 'Capsule',
  'SYP': 'Syrup',
  'INJ': 'Injection',
  'CR': 'Ointments / Creams / Gels',
  'DROP': 'Drops',
  'NEB': 'Nebulization',
  'IV': 'IVFluids',
  'INH': 'Inhaler'
};
const strengthUnitTypes = [
    "mg",
    "ml",
    "grms",
    "mcg",
    "puffs",
    "g",
    "ml/hr",
    "ml/min"
  ];

  const handleProductTypeChange = (index, value) => {
    // Convert short form to full form if needed
  const fullFormValue = medicineTypeMapping[value] || value;
  // Update the local state for the dropdown
  setSelectedProductType(fullFormValue);
  
  // Update the editableData for the specific product
  const updatedProducts = [...editableData.products];
  updatedProducts[index] = {
    ...updatedProducts[index],
    product_type: fullFormValue
    // medicinetype: value
  };
  
  setEditableData({
    ...editableData,
    products: updatedProducts
  });
};

  const handleStrengthUnitChange = (index, value) => {
    console.log('index: ', index)
    console.log('value: ', value)
  // Update the local state for the dropdown
  setSelectedStrengthUnit(value);
  
  // Update the editableData for the specific product
  const updatedProducts = [...editableData.products];
  updatedProducts[index] = {
    ...updatedProducts[index],
    strength_unit: value
  };
  
  setEditableData({
    ...editableData,
    products: updatedProducts
  });
};

// -----------------------------------------------------------------
// Product Name related changes

const [showMedicineNamesDropdown, setShowMedicineNamesDropdown] = useState(-1);
const [suggestions, setSuggestions] = useState([]);
const [dropdownWidth, setDropdownWidth] = useState('auto');
const [focusedItemIndex, setFocusedItemIndex] = useState(-1);

// Create a ref to measure the input width
const inputRef = useRef(null);

// const fetchMedicines = async (medicineName) => {
//   try {
//     const result = await FetchTransferMedicineList({
//       // doctorid,
//       type: "catalog"
//     });
    
//     if (result.output.data.length > 0) {
//       const filtered = result.output.data.filter((obj) =>
//         obj.medicinename?.toLowerCase().includes(medicineName.toLowerCase())
//       );
//       setSuggestions(filtered);
      
//       // Set dropdown width to match input width
//       if (inputRef.current) {
//         setDropdownWidth(`${inputRef.current.offsetWidth}px`);
//       }
//     }
//   } catch (error) {
//     console.error("Error fetching medicines:", error);
//   }
// };

const handleMedicineNameChange = (value, index) => {
  // Update the product name in editableData
  const updatedProducts = [...editableData.products];
  updatedProducts[index] = {
    ...updatedProducts[index],
    product_name: value
  };
  
  setEditableData({
    ...editableData,
    products: updatedProducts
  });

  // Show dropdown and fetch suggestions when length >= 3
  if (value.length >= 3) {
    fetchMedicines(value);
    setShowMedicineNamesDropdown(index);
  } else {
    setSuggestions([]);
    setShowMedicineNamesDropdown(-1);
  }
};

const handleSelect = (suggestion, index) => {
  const updatedProducts = [...editableData.products];
  updatedProducts[index] = {
    ...updatedProducts[index],
    product_name: suggestion.medicinename,
    product_type: suggestion.medicinetype,
    strength: suggestion.dosage,
    strength_unit: suggestion.dosageunit,
    // dosage: suggestion.dosage,
    // dosageunit: suggestion.dosageunit
  };
  
  setEditableData({
    ...editableData,
    products: updatedProducts
  });

  setSuggestions([]);
  setShowMedicineNamesDropdown(-1);
};

const formatDate = (dateString) => {
    if (!dateString) return "-";
    return moment(dateString, "DD-MM-YYYY").format("ddd, D MMM YYYY");
    // return moment(dateString).format("ddd, D MMM YYYY");
  };

  const parseAndFormatDate = (dateString) => {
  if (!dateString) return "-";
  
  // List of possible date formats we might encounter
  const possibleFormats = [
    "DD-MM-YYYY",   // 25-06-2021
    "D-MM-YYYY",    // 5-06-2021
    "DD-M-YYYY",    // 25-6-2021
    "D-M-YYYY",     // 5-6-2021
    "YYYY-MM-DD",   // 2021-06-25 (ISO)
    "MM/DD/YYYY",   // 06/25/2021 (US format)
    "DD/MM/YYYY",   // 25/06/2021 (EU format)
    "DD MMM YYYY",  // 25 Jun 2021
    "MMM DD, YYYY", // Jun 25, 2021
    "YYYYMMDD",     // 20210625
    "x",            // Unix timestamp
  ];

  // Try parsing with strict mode first
  const momentDate = moment(dateString, possibleFormats, true);
  
  // If strict parsing fails, try lenient parsing
  if (!momentDate.isValid()) {
    return moment(dateString).isValid() 
      // ? moment(dateString).format("ddd, D MMM YYYY")
      ? moment(dateString).format("DD-MM-YYYY")
      : "Invalid date";
  }
  
  return momentDate.format("DD-MM-YYYY");
  // return momentDate.format("ddd, D MMM YYYY");
};

// ----------------------------------------------------------------------------------
// Medicine Search Form modal functionality

const medicineSearchModal = useRef(null);
const [MedicineSearchedList, setMedicineSearchedList] = useState([]);
  const [newmedicinedisplaytext, setnewmedicinedisplaytext] = useState("");
const [fieldIndex, setFieldIndex] = useState(null);
const [inputMedicine, setInputMedicine] = useState('');

const TableHeaderMedicines = [
    { key: "medicinename", label: "Medicine Name" },
    // { key: "medicinetype", label: "Medicine Type" },
    { key: "strength", label: "Strength" },
    // { key: "strengthunit", label: "Strength Unit" },
    { key: "manufacturer", label: "Manufacturer" },
    { key: "action", label: "Action" },
  ];

// const openMedicineSearchForm = (name, index) => {
//   setFieldIndex(index)

//   const searchQuery = name?.length > 6 ? name.substring(0, 6) : name;

//   setInputMedicine(searchQuery)
//   setMedicineSearchedList([])
//   fetchMedicines(searchQuery);
//   medicineSearchModal.current.openModal();
// }

const openMedicineSearchForm = (name, index) => {
  setFieldIndex(index);

  // Trim whitespace and take first 6 non-space characters
  const trimmedName = name?.trim();
  const searchQuery = trimmedName?.length > 6 ? trimmedName.substring(0, 6) : trimmedName;

  setInputMedicine(searchQuery);
  setMedicineSearchedList([]);
  
  // Only search if we have a valid query after trim
  if (searchQuery && searchQuery.replace(/\s/g, '').length > 0) {
    fetchMedicines(searchQuery);
    medicineSearchModal.current.openModal();
  } else {
    showErrorToast("Please enter a valid medicine name");
  }
};
const fetchMedicines = async (medicineName) => {
  showLoader();
  try {
    const result = await FetchTransferMedicineList({
      type: "catalog"
    });
    
    if (result.output.data.length > 0) {
      // Trim search query and make case-insensitive
      const cleanQuery = medicineName.trim().toLowerCase();
      const filtered = result.output.data.filter(obj =>
        obj.medicinename?.toLowerCase().includes(cleanQuery)
      );
      
      setMedicineSearchedList(filtered);
      
      // Show message if no matches found
      if (filtered.length === 0) {
        // showErrorToast("No matching medicines found");
        // showErrorToast("No results found for the medicine");
        setnewmedicinedisplaytext("No records found!")
        // setnewmedicinedisplaytext("No medicine data matches your search input!")
      }
    } else {
      setMedicineSearchedList([]);
      showErrorToast("Medicine catalog is empty");
    }
  } catch (error) {
    console.error("Error fetching medicines:", error);
    showErrorToast("Failed to search medicines");
  } finally {
    dismissLoader();
  }
};

// const fetchMedicines = async (medicineName) => {
//   showLoader();
//   try {
//     const result = await FetchTransferMedicineList({
//       // doctorid,
//       type: "catalog"
//     });
    
//     if (result.output.data.length > 0) {
//       const filtered = medicineName 
//         ? result.output.data.filter(obj =>
//             obj.medicinename?.toLowerCase().includes(medicineName.toLowerCase())
//           )
//         : result.output.data;
//       // const filtered = result.output.data.filter((obj) =>
//       //   obj.medicinename?.toLowerCase().includes(medicineName.toLowerCase())
//       // );
//       setMedicineSearchedList(filtered);
//     }else {
//       setMedicineSearchedList([])
//     }
//     dismissLoader();
//   } catch (error) {
//     console.error("Error fetching medicines:", error);
//   }
// };

const HandleClearData = () => {
  setInputMedicine("");
  setMedicineSearchedList([])
  setnewmedicinedisplaytext("")
}
const HandleSearchMedicine = (e) => {
  const value = e.target.value;
  setInputMedicine(value)

  if (value.length >= 6) {
    fetchMedicines(value);
  }
}
const SearchMedicineOnKeyPress = (event) => {
  if (event.key === "Enter") {
    fetchMedicines(inputMedicine);
  }
}

const HandleSearchMedicineClick = async () => {
  await fetchMedicines(inputMedicine)
};

const handleMedicineSelect = (selectedMedicine, fieldIndex) => {
  // Update the specific product in editableData
  const updatedProducts = [...editableData.products];
  updatedProducts[fieldIndex] = {
    ...updatedProducts[fieldIndex],
    product_name: selectedMedicine.medicinename || "",
    product_type: selectedMedicine.medicinetype || "",
    strength: selectedMedicine.dosage || "",
    strength_unit: selectedMedicine.dosageunit || "",
    manufacturer: selectedMedicine.manufacturer || ""
  };

  setEditableData({
    ...editableData,
    products: updatedProducts
  });

  // Close the modal
  medicineSearchModal.current.closeModal();
};


const isChatbotAllowed = () => {
  const subscriptionName = localStorage.getItem("subscriptionName");
  const subscriptionEndDate = localStorage.getItem("subscriptionEndDate");
  
  // If either value is missing, assume chatbot is allowed (or you can handle differently)
  if (!subscriptionName || !subscriptionEndDate) return true;
  
  // Check if subscription is Basic and end date has passed
  const currentDate = new Date();
  const endDate = new Date(subscriptionEndDate);
  
  // return !(subscriptionName === "Basic");
  return !(subscriptionName === "Basic" && currentDate > endDate);
};

  return (
    <>
    {screenType === "web" ? (
      <Box w="100%">
        <Flex>
          <Box w="6rem">
            <MiniSideBar />
          </Box>
          {isLoading && <Loader />}
          <Box w="calc(100vw - 6.25rem)" display="flex" flexDir="column">
            <SecondaryNav
              withBack="Upload Invoice"
              goBack={() => navigate("/procurements")}
            />

            <Flex
              h="calc(100vh - 75px)"
              w="100%"
              justifyContent="center"
              alignItems="center"
              // overflow='hidden auto'
            >
              {/* {hideSection && (<> */}
              {docUpload && (<>
              <Flex flexDir="column" gap="15px" w="calc(100vw - 50%)">
                 <Input
                  type="file"
                  accept=".pdf,.png,.jpg,.jpeg,.docx,.doc"
                  hidden
                  id="uploaddocument"
                  onChange={(e) => handleUploadDocument(e)}
                />
                <Box
                  as="button"
                  flexDir="column"
                  justifyContent="center"
                  alignItems="center"
                  w="100%"
                  p="20px"
                  gap="8px"
                  border="1px dashed #CDCFD4"
                  borderRadius="12px"
                  onClick={handleuploadDocumentAttachment}

                >
                  <Image
                    w="20px"
                    m="auto"
                    mb="10px"
                    h="auto"
                    src="/assets/svgs/file-upload.svg"
                  />
                  <Text fontSize="14px" color="#163E9E" fontWeight="600">
                    Drop files here
                  </Text>
                  
                    <Text fontWeight="400" fontSize="12px" color="#6A707D">
                    {/* PDF (max. 5mb) */}
                    PDF, DOC, PNG, JPG (max. 5mb)
                  </Text>
                </Box>
              </Flex>
              </>)}
               {!Showdata && selectedImages.length > 0 && (
                              <>
                                <Box w="100%">
                                  <Box
                                    w="100%"
                                    p="32px"
                                    bg="#E6E7E9"
                                    overflow="hidden auto"
                                    height="calc(100vh - 70px)"
                                  >
                                    {selectedImages.map((file, index) => (
                                      <Box
                                        key={index}
                                        display="flex"
                                        flexDirection="column"
                                        pb="20px"
                                        alignItems="center"
                                        justifyContent="center"
                                      >
                                        {file.type.includes("pdf") ? (
                                          <Box
                                            as="iframe"
                                            src={file.url}
                                            title={`Document Preview - ${file.name}`}
                                            w={{ base: "100%", md: "calc(100vw - 70%)" }}
                                            boxShadow="rgba(0, 0, 0, 0.24) 0px 3px 8px;"
                                            h="700px"
                                          />
                                        ) : (
                                          <Image
                                            src={file.url}
                                            alt={file.name}
                                            w={{ base: "100%", md: "calc(100vw - 70%)" }}
                                            h="auto"
                                            borderRadius="8px"
                                            boxShadow="rgba(0, 0, 0, 0.24) 0px 3px 8px;"
                                          />
                                        )}
                                        <Text fontSize="14px" mt="8px">{file.name}</Text>
                                        <Button 
                                          mt="10px" 
                                          onClick={() => handleRemoveFile(file.name)} 
                                          colorScheme="red"
                                        >
                                          Remove
                                        </Button>
                                      </Box>
                                    ))}
                                  </Box>
              
                                  {previewDoc && (
                                    <Box
                                      w={{ base: "100%", md: "calc(100vw - 70%)" }}
                                      display="flex"
                                      marginInline="auto"
                                      alignItems="center"
                                      gap="20px"
                                      pos="sticky"
                                      bottom="0"
                                    >
                                      <Input
                                        type="file"
                                        accept=".pdf,.png,.jpg"
                                        hidden
                                        id="uploaddocument"
                                        multiple
                                        onChange={(e) => handleUploadDocument(e)}
                                      />
                                      <PrimaryButton
                                        buttonText="Re-upload"
                                        id="uploaddocument"
                                        variant="grayBtnFull"
                                        onClick={handleuploadDocumentAttachment}
                                      />
                                        {/* <PrimaryButton onClick={handleUploadFiles} buttonText="Confirm" /> */}
                                        <PrimaryButton 
      onClick={handleUploadFiles} 
      buttonText="Confirm"
      isDisabled={!isChatbotAllowed()}
      opacity={isChatbotAllowed() ? 1 : 0.6}
      cursor={isChatbotAllowed() ? "pointer" : "not-allowed"}
      title={!isChatbotAllowed() ? "Please upgrade your subscription to use AI features" : ""}
    />
                                    </Box>
                                  )}
                                </Box>
                              </>
              )}
               {Showdata && data && data.products?.length > 0 ? (
                  <Box my="1rem" w='100%'  mt="0.5rem">
                     <Box
                      gap="10px"
                      marginTop="4rem"
                      marginBottom="1rem"
                      px="1.5rem"
                      w="100%"
                      display="flex"
                      flexDirection="row"
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <Box
                        gap="10px"
                        // pl="1rem"
                        w="100%"
                        display="flex"
                        flexDirection="row"
                        justifyContent="start"
                        alignItems="center"
                      >
                      <Box display="flex" flexDir="column" w={"100%"}>
                          {/* <Text fontSize="10px" color="gray.500">
                              Supplier Name
                          </Text>
                          <Text fontSize="12px" fontWeight="600">
                              {data.name_of_company ? data.name_of_company : "-"}
                          </Text> */}
                          <DropdownInputForVitals
                                  variant="bothSide"
                                  dropDownPlace="Supplier Name"
                                  arrowCSS={{pr:0}}
                                  options={supplierOptions}
                                  readOnly=""
                                  maxLength={70}
                                  onClick={handleSupplierSelect}
                                  onChange={handleInputSupplierChange}
                                  value={selectedSupplier || data?.name_of_company || ''}
                                  inputValueProp={selectedSupplier || data?.name_of_company || ''}
                                  
                                />
                     </Box>
                      <Box display="flex" flexDir="column" w={"100%"}>
                          <PrimaryInput
                            inputPlace="Invoice Number"
                            variant="bothSide"
                            // defaultValue={editableData.invoice_no ? editableData.invoice_no : ''}
                            defaultValue={data.invoice_no ? data.invoice_no : ''}
                            onChange={(e) => handleInvoiceDetailsChange('invoice_no', e.target.value)}
                          />
                     </Box>
                      <Box display="flex" flexDir="column" w={"100%"}>
                          {/* <Text fontSize="10px" color="gray.500">
                              Invoice Date
                          </Text>
                          <Text fontSize="12px" fontWeight="600">
                              {data.invoice_date ? parseAndFormatDate(data.invoice_date) : "-"}
                          </Text> */}
                          <DatePicker
                            placeholderProp="Invoice Date"
                            datePickerInputStyle={{ borderRadius: "10px 10px 10px 10px" }}
                            defaultDate={data.invoice_date ? parseAndFormatDate(data.invoice_date) : ""}
                            onDateChange={handleDateChange}
                            CUSTOM_DISABLE={false}
                            // value={invoiceDate ? invoiceDate : parseAndFormatDate(data.invoice_date)}
                            // minDate={new Date(2000, 0, 1)} // Set minimum date if needed
                            // maxDate={new Date()} // Disable future dates if needed
                          />
                     </Box>
                       <Box display="flex" flexDir="column" w={"100%"}>
                          <PrimaryInput
                            inputPlace="GST Number"
                            variant="bothSide"
                            // defaultValue={editableData.GSTIN ? editableData.GSTIN : ''}
                            defaultValue={data.GSTIN ? data.GSTIN : ''}
                            onChange={(e) => handleInvoiceDetailsChange('GSTIN', e.target.value)}
                          />
                     </Box>
                      <Box display="flex" flexDir="column" w={"100%"}>
                          <PrimaryInput
                            inputPlace="Total Amount"
                            variant="bothSide"
                            defaultValue={data.grand_total_amount ? data.grand_total_amount : ''}
                            onChange={(e) => handleInvoiceDetailsChange('grand_total_amount', e.target.value)}
                          />
                     </Box>
                      </Box>
                    </Box>
                    <Box
                    h="calc(100vh - 90px)"
                    // overflow='hidden auto'
                    border="1px solid #E6E7E9"
                    >
                      <SimpleTable
                        headers={TableHeader}
                        isThCss={{px:"0", textAlign:"left"}}
                        className='tableContainer'
                        isDataPresent={true}
                        // tableHeader={{zIndex: "999999"}}
                        //currentPage={currentPage} onPageChange={handlePageChange}
                        footerStyle={{pos: "fixed", bottom: "0px",boxShadow: "rgba(0, 0, 0, 0.15) 0px 5px 15px 0px", zIndex: "99", w: "100%"}}
                        tableStyle={{minH:"calc(100vh - 205px)",maxH:"calc(100vh - 205px)",overflowY: "auto",overflowX: "hidden", tableLayout: "fixed", width: "100%"}}
                        tableBody={
                          <>
                          {/* {data && data?.products.map((step, index) => ( */}
                            {editableData?.products.map((step, index) => (
                              <Tr w="100%" key={index}>
                                <Td p='0'>
                                  {/* <Text fontSize=".875rem" isTruncated title={step.HSN} fontWeight="500">
                                    {step.HSN ? step.HSN : '-'}
                                  </Text> */}
                                  <PrimaryInput
                                    inputPlace="HSN"
                                    variant="bothSide"
                                    defaultValue={step.HSN ? step.HSN : ""}
                                    onChange={(e) => handleInputChange(index, 'HSN', e.target.value)}
                                  />
                                </Td>
                                <Td p='0' w='200px' pos="relative">
  <Box w="100%" pos="relative" cursor="pointer" ref={inputRef}>
    <PrimaryInput
      variant="bothSide"
      inputPlace="Product name*"
      id={`productname-${index}`}
      defaultValue={step.product_name || ""}
      inputValue={step.product_name || ""}
      // onChange={(e) => handleMedicineNameChange(e.target.value, index)}
      autocomplete="off"
      inputCssStyle={{
        pr: "36px",
        _hover: { border: "1px solid", borderRadius: "10px" }
      }}
      maxLength={50}
    />
    <Image
      top="33%"
      right="6.5%"
      w="15px"
      pos="absolute"
      src="/assets/imgs/search.png"
      onClick={() => {
        openMedicineSearchForm(step.product_name, index);
        // e.preventDefault();
        // if (actionAccess && actionAccess.create) {
        //   openNewVisitForm();
        // }
      }}
    />
  </Box>
</Td>

{/* existing working functionality of dropdown */}
                                {/* <Td p='0' w='200px' pos="relative">
  <Box w="100%" pos="relative" cursor="pointer" ref={inputRef}>
    <PrimaryInput
      variant="bothSide"
      inputPlace="Product name"
      id={`productname-${index}`}
      defaultValue={step.product_number || ""}
      inputValue={step.product_number || ""}
      // value={step.product_number || ""}
      onChange={(e) => handleMedicineNameChange(e.target.value, index)}
      // onClick={(e) => handleMedicineNameChange(e.target.value, index)}
      autocomplete="off"
      inputCssStyle={{
        pr: "36px",
        _hover: { border: "1px solid", borderRadius: "10px" }
      }}
      maxLength={50}
    />
    <Image
      top="33%"
      right="6.5%"
      w="15px"
      pos="absolute"
      src="/assets/imgs/search.png"
    />
  </Box>
  
  {showMedicineNamesDropdown === index && suggestions.length > 0 && (
    <Box
      pos="absolute"
      w={dropdownWidth} // Use measured width
      bg="white"
      border="1px solid #E6E7E9"
      borderRadius="0 0 12px 12px"
      zIndex="999"
      maxH="150px"
      overflowY="auto"
      boxShadow="md"
      left="0"
    >
      {suggestions.map((suggestion, sIndex) => (
        <Box
          key={sIndex}
          p="0.5rem 1rem"
          borderBottom="1px solid #E6E7E9"
          bg={focusedItemIndex === sIndex ? "#f0f0f0" : "white"}
          _hover={{ bg: "#f0f0f0" }}
          cursor="pointer"
          onClick={() => handleSelect(suggestion, index)}
          onMouseEnter={() => setFocusedItemIndex(sIndex)}
        >
          <Text fontSize="0.875rem" fontWeight="500">
            {suggestion.medicinename} {suggestion.dosage} {suggestion.dosageunit} ({suggestion.medicinetype})
          </Text>
        </Box>
      ))}
    </Box>
  )}
</Td> */}
                                <Td p='0'>
                                  {/* <PrimaryInput
                                    inputPlace="Product Type"
                                    variant="bothSide"
                                    defaultValue={step.medicinetype ? step.medicinetype : ''}
                                    onChange={(e) => handleInputChange(index, 'producttype', e.target.value)}
                                  /> */}
                                  <DropdownInputForVitals
                                  variant="bothSide"
                                  dropDownPlace="Product Type*"
                                  arrowCSS={{pr:0}}
                                  options={medicineTypes}
                                  readOnly=""
                                  maxLength={70}
                                  // onClick={(selectedOption) =>
                                  //   handlemedicinetypechange(selectedOption, "filter")
                                  // }
                                  // onClick={handleProductTypeSelect}
                                  // // onChange={handleInputTypeChange}
                                  // onChange={(e) => handleInputChange(index, 'producttype', e.target.value)}
                                  
                                  // value={step?.product_type || ''}
                                  // inputValueProp={step?.product_type || ''}
                                  value={medicineTypeMapping[editableData.products[index]?.product_type] || 
                                  editableData.products[index]?.product_type}
                                  inputValueProp={medicineTypeMapping[editableData.products[index]?.product_type] || 
                                  editableData.products[index]?.product_type}
                                  // value={selectedProductType || step?.producttype || ''}
                                  // inputValueProp={selectedProductType || step?.producttype || ''}
                                  onClick={(value) => handleProductTypeChange(index, value)}
                                  onChange={(e) => handleProductTypeChange(index, e.target.value)}
                                />
                                </Td>
                                <Td p='0'>
                                  <PrimaryInput
                                    inputPlace="Strength*"
                                    variant="bothSide"
                                    defaultValue={step.strength ? step.strength : ''}
                                    inputValue={step.strength ? step.strength : ''}
                                    onChange={(e) => handleInputChange(index, 'strength', e.target.value)}
                                  />
                                </Td>
                                <Td p='0' minW='100px'>
                                  {/* <PrimaryInput
                                    inputPlace="UOS"
                                    variant="bothSide"
                                    defaultValue={step.strengthunit ? step.strengthunit : ''}
                                    onChange={(e) => handleInputChange(index, 'strengthunit', e.target.value)}
                                  /> */}
                                  <DropdownInputForVitals
                                  variant="bothSide"
                                  dropDownPlace="Strength Unit*"
                                  arrowCSS={{pr:0}}
                                  options={strengthUnitTypes}
                                  readOnly=""
                                  maxLength={20}
                                  value={step?.strength_unit || ''}
                                  inputValueProp={step?.strength_unit || ''}
                                  // value={selectedStrengthUnit || step?.producttype || ''}
                                  // inputValueProp={selectedStrengthUnit || step?.producttype || ''}
                                  onClick={(value) => handleStrengthUnitChange(index, value)}
                                  onChange={(e) => handleStrengthUnitChange(index, e.target.value)}
                                />
                                </Td>
                                <Td p='0' w='170px'>
                                  <PrimaryInput
                                    inputPlace="Pack*"
                                    variant="bothSide"
                                    defaultValue={step.pack ? step.pack : ''}
                                    onChange={(e) => handleInputChange(index, 'pack', e.target.value)}
                                  />
                                </Td>
                                <Td p='0' w='110px'>
                                  <PrimaryInput
                                    inputPlace="QTY*"
                                    variant="bothSide"
                                    defaultValue={step.qty ? step.qty : ''}
                                    onChange={(e) => handleInputChange(index, 'qty', e.target.value)}
                                  />
                                </Td>
                                <Td p='0' w='110px'>
                                  <PrimaryInput
                                    variant="bothSide"
                                    inputPlace="MRP"
                                    defaultValue={step.MRP ? step.MRP : ""}
                                    onChange={(e) => handleInputChange(index, 'MRP', e.target.value)}
                                  />
                                </Td>
                                <Td p='0'>
                                  <PrimaryInput
                                    inputPlace="Batch*"
                                    variant="bothSide"
                                    defaultValue={step.batch ? step.batch : ""}
                                    onChange={(e) => handleInputChange(index, 'batch', e.target.value)}
                                  />
                                </Td>
                                <Td p='0' w='110px'>
                                  {/* <Text fontSize=".875rem" fontWeight="500">
                                    {step.exp}
                                  </Text> */}
                                  <PrimaryInput
                                    inputPlace="Exp*"
                                    variant="bothSide"
                                    defaultValue={step.exp ? step.exp : ''}
                                    onChange={(e) => handleInputChange(index, 'exp', e.target.value)}
                                  />
                                </Td>
                                <Td p='0'>
                                  <PrimaryInput
                                    inputPlace="Amount"
                                    variant="bothSide"
                                    defaultValue={step.amount ? step.amount : ''}
                                    onChange={(e) => handleInputChange(index, 'amount', e.target.value)}
                                  />
                                </Td>
                              </Tr>
                            ))}
                          </>
                        }
                       footerSection={
                          <>
                            <Flex
                            gap="1rem"
                            p="0.75rem 0.875rem"
                            justify="flex-end"
                            width="calc(100vw - 6rem)"
                            wrap="wrap"
                          >
                            <PrimaryButton variant="mdBtn" buttonText="Refetch Invoice" onClick={handleRefetchInvoice} />

                            <PrimaryButton variant="mdBtn" buttonText="Save" onClick={saveInvoice} />
                          </Flex>
                          </>
                        }
                      />
                    </Box>
                  </Box>
              ) : (
                // <SimpleTable
                //   headers={TableHeader}
                //   isDataPresent={false}
                // />
                null
              )}
            </Flex>
          </Box>
        </Flex>
      </Box>
      ) : (
        <>  
         <MobileNavbar />
         {isLoading && <Loader />}
          <MobileSecondaryNav
            header="Upload Invoice"
            handlebackarrow={() => navigate(`/home`)}
          />
          <Flex
              h="calc(100vh - 145px)"
              w="100%"
              justifyContent="center"
              alignItems="center"
              overflow='hidden auto'
            >
              {/* {hideSection && (<> */}
              {docUpload && (<>
              <Flex flexDir="column" gap="15px" w="calc(100vw - 50%)">
                  <Input
                  type="file"
                  //accept=".pdf,.png,.jpg,.docx,.doc"
                  accept=".pdf"
                  hidden
                  id="uploaddocument"
                  onChange={(e) => handleUploadDocument(e)}
                />

               
                <Box
                  as="button"
                  flexDir="column"
                  justifyContent="center"
                  alignItems="center"
                  w="100%"
                  p="20px"
                  gap="8px"
                  border="1px dashed #CDCFD4"
                  borderRadius="12px"
                  onClick={handleuploadDocumentAttachment}

                >
                  <Image
                    w="20px"
                    m="auto"
                    mb="10px"
                    h="auto"
                    src="/assets/svgs/file-upload.svg"
                  />
                  <Text fontSize="14px" color="#163E9E" fontWeight="600">
                    Drop files here
                  </Text>
                  {dischargeSummary == 1 ? (
                  <Text fontWeight="400" fontSize="12px" color="#6A707D">
                  {/* PDF (max. 5mb) */}
                  PDF, DOC, PNG, JPG (max. 5mb)
                  </Text>
                  ):(
                    <Text fontWeight="400" fontSize="12px" color="#6A707D">
                    PDF (max. 5mb)
                    {/* PDF, DOC, PNG, JPG (max. 5mb) */}
                  </Text>
                  )}
                </Box>
              </Flex>
              </>)}
            </Flex>
        </>
      )}

    
    {/* Medicine Search Modal */}
    <DynamicModal
        ref={medicineSearchModal}
        // hasBackBtn={ShowNewVisit ? true : false}
        modalHeader="Search Medicine"
        // withBackHeader="New Visit"
        // backOnClick={() => setShowNewVisit(false)}
        modalWidth={{ base: "100%", md: "50%" }}
        modalBody={
          <>
            <Box bg={"#fcfcfd"}>
              {/* {!ShowNewVisit && */}
                <>
                  <Text fontSize='1rem'>
                    {"Please use the search option to look up for existing medicine information"}
                  </Text>
                  <Box display='flex' gap='0.75rem' my='0.5rem'>

                    <Box w='100%' position='relative'>
                      <Box w='100%'>
                        <PrimaryInput
                          inputPlace='Search by medicine name'
                          variant='fullRound'
                          inputValue={inputMedicine}
                          // value={inputMedicine}
                          // defaultValue={inputMedicine}
                          onKeyPress={SearchMedicineOnKeyPress}
                          onChange={HandleSearchMedicine}
                        />
                      </Box>
                    </Box>
                    <Flex gap='0.75rem'>
                      <PrimaryButton buttonText='Search' 
                      onClick={HandleSearchMedicineClick} 
                      />
                      {/* {showClearBtn && */}
                        <PrimaryButton buttonText='Clear' variant='grayBtn' 
                        onClick={HandleClearData} 
                        btnStyle={{ w: '50%', h: '48px', color: 'black' }} />
                      {/* } */}
                    </Flex>
                  </Box>
                  {MedicineSearchedList && MedicineSearchedList.length > 0 &&
                    <Box
                      border="1px solid #E6E7E9"
                      mt='1rem'
                    >
                      <SimpleTable
                        headers={TableHeaderMedicines}
                        className='tableContainer'
                        isDataPresent={true}
                        tableStyle={{ maxH: "calc(100vh - 320px)", overflowY: "auto", overflowX: "auto", tableLayout: "fixed", width: "100%" }}
                        tableBody={
                          <>
                            {MedicineSearchedList &&
                              MedicineSearchedList.map((step, index) => (
                                <Tr cursor='pointer' w="100%" key={index} 
                                // onClick={() => handlepatientSelected(step)}
                                >
                                  <Td w="100x">
                                    <Box w="100%" display="flex" gap="0.5rem" alignItems="center">
                                      <Text>{step .medicinename ? step .medicinename : "-"}</Text>
                                      {step.medicinetype && (
                                        <Box
                                          as="span"
                                          bg="#E6E7E966"
                                          mr="0.25rem"
                                          border="1px solid #E6E7E9"
                                          borderRadius="8px"
                                          fontSize="10px"
                                          px="8px"
                                        >
                                          {step.medicinetype}
                                        </Box>
                                      )}
                                      {/* <Box w="80%" maxW="8rem" isTruncated>
                                        <Text
                                          className="textOverflow"
                                          fontSize=".875rem"
                                          fontWeight="600"
                                          title={step.medicinename}
                                        >
                                          {step.medicinename
                                            ? step.medicinename
                                            : "-"}
                                        </Text>
                                      </Box> */}
                                    </Box>
                                  </Td>

                                  <Td>
                                    <Box w="100%" display="flex" gap="0.5rem" alignItems="center">
                                    <Text fontSize=".875rem" fontWeight="500">
                                      {step.dosage ? step.dosage : "-"}
                                    </Text>
                                    <Text fontSize=".875rem" fontWeight="500">
                                      {step.dosageunit ? step.dosageunit : ""}
                                    </Text>

                                    </Box>
                                  </Td>
                                  {/* <Td>
                                    <Text fontSize=".875rem" fontWeight="500">
                                      {step.dosageunit ? step.dosageunit : "-"}
                                    </Text>
                                  </Td> */}
                                  <Td maxW='8rem'>
                                    <Text fontSize=".875rem" fontWeight="500" title={step.manufacturer} isTruncated>
                                      {step.manufacturer ? step.manufacturer : "-"}
                                    </Text>
                                  </Td>
                                  {/* <Td w="80%" maxW="8rem">
                                    <Text title={step.relation ? step.relation : "-"} textTransform='capitalize' isTruncated fontSize=".875rem" fontWeight="500">
                                      {step.relation ? step.relation : "-"}
                                    </Text>
                                  </Td> */}

                                  {/* <Td maxW="8rem">
                                    <Text fontSize=".875rem" fontWeight="500" title={step.patientaddress ? step.patientaddress : ""} isTruncated>
                                      {step.patientaddress ? step.patientaddress : "-"}
                                    </Text>
                                  </Td> */}

                                  <Td>
                                      <PrimaryButton
                                        buttonText="Select"
                                        variant="grayBtn"
                                        // onClick={()=>openTransferModal(item)}
                                        onClick={() => handleMedicineSelect(step, fieldIndex)}
                                        btnStyle={{ color: "#000", w: "100px" }}
                                      />
                                  </Td>

                                </Tr>
                              ))}
                          </>
                        }
                      />
                    </Box>
                  }
                  {MedicineSearchedList && MedicineSearchedList.length === 0 && (
                                      <Flex w='100%' flexDir='column' h='200px' justifyContent='center' alignItems='center' my='1rem' gap='0.5rem'>
                                        <Text fontSize='1rem'>
                                          {newmedicinedisplaytext ? newmedicinedisplaytext : ""}
                                        </Text>
                                      </Flex>
                                    )}
                </>
              {/* } */}
            </Box>
          </>
        }
      />

    </>
  );
};

export default UploadInvoice;
